import React, { useEffect, useState } from 'react'
import { Accordion } from 'react-bootstrap'
import { CommonInput, CustomSelect } from 'components'
import { constant } from 'constants/constant'
import { utils } from 'helper'
import { AddButton } from 'components/common/CommonButton';
import toast from 'react-hot-toast'
import { useNavigate, useParams } from 'react-router-dom'
import { updateGpsSettings } from '_services/accountsServices/vehicleDocTypeServices'
import StorageService from 'utils/StorageServices/StorageServices'

const VehicleGpsSetting = (props) => {

  let { id } = useParams();
  let { callApiVehicleDetails = () => { }, singleVehicleData } = props;
  const navigate = useNavigate();

  const formObj = {
    company_id: StorageService.getCompanyId(),
    vehicle_id: id,
    speed_limit: '',
    harsh_braking_threshold: '',
    ideal_duration_minutes: '',
    gps_inactive_duration_hours: '',
    on_trip_hours: '',
    empty_hours: '',
  }

  const [formValue, setFormValue] = useState(formObj);
  const [loading, setLoading] = useState(false);

  const handleOnChange = async (name, value) => {
    const stateObj = { ...formValue, [name]: value };
    setFormValue(stateObj);
  };

  const onhandleSelect = async (item, name) => {
    const stateObj = { ...formValue, [name]: item };
    setFormValue(stateObj);
  };

  const submitSettings = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let payload = {
        company_id: formValue?.company_id,
        vehicle_id: formValue?.vehicle_id,
        gps_settings: {
          speed_limit: +formValue?.speed_limit,
          harsh_braking_threshold: +formValue?.harsh_braking_threshold,
          ideal_duration_minutes: formValue?.ideal_duration_minutes?.value,
          gps_inactive_duration_hours: formValue?.gps_inactive_duration_hours?.value,
          stoppage_duration: {
            on_trip_hours: formValue?.on_trip_hours?.value,
            empty_hours: formValue?.empty_hours?.value,
          }
        }
      }
      const res = await updateGpsSettings(payload);
      if (res?.responseCode == 200) {
        callApiVehicleDetails();
        toast.success(`Vehicle GPS Settings Updated`);
        setLoading(false);
      } else {
        toast.error('Something went wrong, Settings Not Updated');
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      toast.error('Something went wrong, Settings Not Updated');
    }
  }

  useEffect(() => {
    if (singleVehicleData?.gps_settings) {
      setFormValue((s) => ({
        ...s,
        company_id: singleVehicleData?.company_id ? singleVehicleData?.company_id : StorageService.getCompanyId(),
        vehicle_id: singleVehicleData?._id,
        speed_limit: singleVehicleData?.gps_settings?.speed_limit,
        harsh_braking_threshold: singleVehicleData?.gps_settings?.harsh_braking_threshold,
        ideal_duration_minutes: constant?.minutesArray?.find((el) => el?.value === singleVehicleData?.gps_settings?.ideal_duration_minutes),
        gps_inactive_duration_hours: constant.hoursArray?.find((el) => el?.value === singleVehicleData?.gps_settings?.gps_inactive_alerts?.hours),
        on_trip_hours: constant.hoursArray?.find((el) => el?.value === singleVehicleData?.gps_settings?.stoppage?.on_trip?.hours),
        empty_hours: constant.hoursArray?.find((el) => el?.value === singleVehicleData?.gps_settings?.stoppage?.empty?.hours),
      }))
    }
  }, [singleVehicleData, constant?.minutesArray, constant.hoursArray])

  return (
    <>
      <div className='__vhlMain_fx __vhlMain_gps'>
        <div className=' __vhlMain_gpsSetting'>
          <div className='__stMain' style={{height:'auto'}}>
            <Accordion className='__setingAccordian' alwaysOpen>
              <Accordion.Item eventKey="0">
                <Accordion.Header >Speed Limit</Accordion.Header>
                <Accordion.Body>
                  <div className='__setf_branc_sepBx'>
                    <div className='_brxFlex'>
                      <div className='_dLass'>
                        <CommonInput
                          type="text"
                          label="Set Speed Limit"
                          placeholder="Set Speed Limit"
                          name="speed_limit"
                          maxLength="3"
                          onInput={utils.maxLengthCheck}
                          onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                          value={formValue.speed_limit}
                          onChange={(e) => utils.withoutDotLettersSpaceSpecialCharacters(e, handleOnChange)}
                        />
                      </div>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1">
                <Accordion.Header >Harsh Breaking</Accordion.Header>
                <Accordion.Body>
                  <div className='__setf_branc_sepBx'>
                    <div className='_brxFlex'>
                      <div className='_dLass'>
                        <CommonInput
                          type="text"
                          label="Speed Suddenly Fall to %"
                          placeholder="Speed Suddenly Fall to %"
                          name="harsh_braking_threshold"
                          maxLength="3"
                          onInput={utils.maxLengthCheck}
                          onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                          value={formValue.harsh_braking_threshold}
                          onChange={(e) => utils.withoutDotLettersSpaceSpecialCharacters(e, handleOnChange)}
                        />
                      </div>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2">
                <Accordion.Header >Ideal Duration</Accordion.Header>
                <Accordion.Body>
                  <div className='__setf_branc_sepBx'>
                    <div className='_brxFlex'>
                      <div className='_dLass'>
                        <CustomSelect
                          options={constant.minutesArray}
                          name="ideal_duration_minutes"
                          placeholder="Ideal Duration"
                          value={formValue?.ideal_duration_minutes?.value ? formValue?.ideal_duration_minutes : {}}
                          onSelect={(data) => onhandleSelect(data, 'ideal_duration_minutes')}
                        />
                      </div>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3">
                <Accordion.Header >GPS Inactive Alerts</Accordion.Header>
                <Accordion.Body>
                  <div className='__setf_branc_sepBx'>
                    <div className='_brxFlex'>
                      <div className='_dLass'>
                        <CustomSelect
                          options={constant.hoursArray}
                          name="gps_inactive_duration_hours"
                          placeholder="Location not received from"
                          value={formValue?.gps_inactive_duration_hours?.value ? formValue?.gps_inactive_duration_hours : {}}
                          onSelect={(data) => onhandleSelect(data, 'gps_inactive_duration_hours')}
                        />
                      </div>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="4">
                <Accordion.Header >Stoppage</Accordion.Header>
                <Accordion.Body>
                  <div className='__setf_branc_sepBx'>
                    <div className='_brxFlex'>
                      <div className='_dLass'>
                        <CustomSelect
                          options={constant.hoursArray}
                          name="on_trip_hours"
                          placeholder="On Trip"
                          isDropdownTop={true}
                          value={formValue?.on_trip_hours?.value ? formValue?.on_trip_hours : {}}
                          onSelect={(data) => onhandleSelect(data, 'on_trip_hours')}
                        />
                      </div>
                      <div className='_dLass'>
                        <CustomSelect
                          options={constant.hoursArray}
                          name="empty_hours"
                          placeholder="Empty"
                          isDropdownTop={true}
                          value={formValue?.empty_hours?.value ? formValue?.empty_hours : {}}
                          onSelect={(data) => onhandleSelect(data, 'empty_hours')}
                        />
                      </div>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </div>
      <div className="bottomFix">
        <AddButton onClick={(e) => submitSettings(e)} name={loading ? 'Loading...' : "Save Changes"} type="button" disabled={loading} />
        <button className="_cancel_btn" onClick={(e) => navigate(-1)}> Cancel </button>
      </div>
      
    </>
  )
}

export default VehicleGpsSetting